import styled from 'styled-components';

import { OnboardingPage } from '../../../../components/Page';

export const ScreenExperienceGalleryStyles = styled(OnboardingPage)`
  .local-title {
    margin: 0 0 8px;
  }

  ion-content {
    &::part(scroll) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
      padding: 26px 0;
    }
  }
`;

export const ChatWrapperStyles = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const ChatContainerStyles = styled.div`
  position: absolute;
  bottom: 5%;
  left: 48px;
  right: 48px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: flex-end;
  margin-bottom: 200px;
`;

export const AnimatedBottomButtonContainer = styled.div<{ show: boolean }>`
  position: fixed;
  bottom: 34px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  max-width: 500px;
  width: 100%;
  padding: 0 16px;
  opacity: ${({ show }) => (show ? 1 : 0)};
  transform: ${({ show }) =>
    show
      ? 'translateX(-50%) translateY(0)'
      : 'translateX(-50%) translateY(100px)'};
  transition:
    opacity 0.5s ease,
    transform 0.5s ease;
`;
